// extracted by mini-css-extract-plugin
export default {"selectError":"Select_selectError__MqJVs","text":"Select_text__-Wi9q","icon":"Select_icon__ISXb9","selectNone":"Select_selectNone__bm9ap"};